import _regeneratorRuntime from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/helpers/asyncToGenerator';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from '~/plugins/axios.js';

import exyteLogo from '~/assets/img/exyte.png';
import packageJson from '~/package.json';

var baseUrl = '/';

export default {
  components: {},
  name: "default-header",
  data: function data() {
    return {
      exyteLogoUrl: exyteLogo,
      mainPath: {
        baseUrl: baseUrl,
        mainPage: baseUrl + 'mainPage',
        dashboard: baseUrl + 'dashboard/',
        comboBook: baseUrl + 'comboBook/',
        tvCal: baseUrl + 'tvCalendar/'
      },
      isLoggedIn: !!this.$store.state.authUser || null,
      userFlag: !!this.$store.state.authUser ? this.$store.state.authUser.flag : null,
      userFullname: !!this.$store.state.authUser ? this.$store.state.authUser.fullname : null,
      version: packageJson["version"]
    };
  },

  computed: {
    displayLoginInfo: function displayLoginInfo() {
      if (!!this.$store.state.authUser) return this.$store.state.authUser.flag + ' - ' + this.$store.state.authUser.fullname || null;
    }
  },
  methods: {
    userLogout: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return axios.post('/users/logout', null);

              case 2:
                this.$store.commit('setUser', null);
                window.location.reload(true);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function userLogout() {
        return _ref.apply(this, arguments);
      }

      return userLogout;
    }()
  },
  mounted: function mounted() {}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/home/ubuntu/BookingSystemV2/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/DefaultHeader.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/home/ubuntu/BookingSystemV2/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/DefaultHeader.vue
// module chunks = 9 11